import { Button } from '@bp/ui-components';
import classNames from 'classnames';
import type { BpActionButton } from 'components/BpCard/BpCard';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useWindowDimensions } from 'utils/dimensions';
import styles from './ModalBottomButtons.module.scss';

type ModalBottomButtonsProps = {
  closeButton: BpActionButton;
  submitButton?: BpActionButton;
  additionalButtons?: BpActionButton[];
  isModal?: boolean;
  isLoading: boolean;
  errors: unknown;
  className?: string | undefined;
  errorText?: string | null;
};

export const ModalBottomButtons: FC<ModalBottomButtonsProps> = ({
  closeButton,
  submitButton,
  additionalButtons,
  isModal = false,
  isLoading = false,
  errors,
  className,
  errorText,
}) => {
  const { t } = useTranslation();

  const { isPhone, isTablet } = useWindowDimensions();
  const isMobile = isPhone || isTablet;

  const classes = classNames(styles['modal-bottom-buttons'], { 'bp__modal-footer': isModal }, className);

  return (
    <div>
      <div className={classes}>
        <Button
          hierarchy={isMobile ? 'secondary' : 'tertiary'}
          onClick={closeButton.callback}
          onKeyUp={(e) => e.key === 'Escape'}
        >
          {closeButton.text ?? t('common.cancel')}
        </Button>
        {additionalButtons?.map((button, index) => {
          return (
            <Button
              key={index}
              disabled={button.disabled}
              icon={button.icon}
              iconPosition={button.iconPosition ?? 'left'}
              hierarchy={isMobile ? 'secondary' : (button.hierarchy ?? 'secondary')}
              onClick={button.callback}
              type='button'
            >
              {button.text}
            </Button>
          );
        })}
        <Button
          isLoading={isLoading}
          type='submit'
          hierarchy='primary'
          disabled={(errors ? Object.values(errors).length > 0 : false) || submitButton?.disabled}
          {...(submitButton?.callback ? { onClick: submitButton.callback } : {})}
          onKeyUp={(e) => e.key === 'Enter'}
        >
          {submitButton?.text ?? t('common.save')}
        </Button>
      </div>
      {errorText && (
        <p
          style={{
            textAlign: 'right',
            marginTop: '10px',
            fontSize: 'var(--font-size-xs)',
            color: 'var(--color-error)',
          }}
        >
          {errorText}
        </p>
      )}
    </div>
  );
};
